var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"webView",staticClass:"main-iframe",attrs:{"src":_vm.src,"id":"show-iframe","allowfullscreen":"","webkitallowfullscreen":"","mozallowfullscreen":""}})}
var staticRenderFns = []

export { render, staticRenderFns }